import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SERVER_API_URL } from '../../../app.constants';
import { Location } from '../model/location';
import { LocationSearchRequest } from '../model/location-search-request.model';
import { createRequestOption } from '../..';
import { InventoryContext } from '../../../inventory-manager/inventory.context';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LocationService {

    constructor(private http: HttpClient,
                private inventoryContext: InventoryContext) {
    }

    searchLocations(request: LocationSearchRequest, favoriteLocation: boolean, pagination: any): Observable<Location[]> {
        // TODO: remove once pagination is implemented in location dropdowns
        if (!pagination) {
            pagination = {
                page: 0,
                size: 10000
            };
        }

        if (favoriteLocation) {
            request.filterFavoriteProgramUUID = true;
            request.favoriteProgramUUID = this.inventoryContext.programUUID;
        }

        const params = createRequestOption(pagination);
        const url = SERVER_API_URL + `crops/${this.inventoryContext.cropName}/locations/search?programUUID=${this.inventoryContext.programUUID}`;
        return this.http.post<Location[]>(url, request, { params, observe: 'response' })
            .pipe(map((res: HttpResponse<Location[]>) => res.body));
    }

    getDefaultStorageLocation(): Observable<Location> {
        const storageLocation = 'STORAGE_LOCATION';
        return this.http.get<Location>(SERVER_API_URL
            + `crops/${this.inventoryContext.cropName}/programs/${this.inventoryContext.programUUID}/locations/default/${storageLocation}`,
        { observe: 'response' }).pipe(map((res: HttpResponse<Location>) => res.body));
    }
}
